import type { TypeOrArray } from 'contracts';

const toArray = <T>(source: TypeOrArray<T>): Array<T> => (Array.isArray(source) ? source : [source]);

export default toArray;
